module.exports = function getResource(label, vars = []) {
    const resources = {
        free: 'GRATUIT',
        value: 'valeur'

    };
    return resources[label];
};
